module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voice-intelligence-dashboard"
  }, [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_vm._m(0), _vm._v(" "), (_vm.isShowFilter) ? _c('div', {
    staticClass: "header-item"
  }, [_c('span', {
    staticClass: "fa fa-fw fa-clock-o"
  }), _vm._v(" "), _c('strong', [_vm._v("View by Show |")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "Select slot",
      "loading": _vm.loadingTimeslots
    },
    on: {
      "change": _vm.onTimeslotChanged
    },
    model: {
      value: (_vm.selectedTimeslot),
      callback: function($$v) {
        _vm.selectedTimeslot = $$v
      },
      expression: "selectedTimeslot"
    }
  }, _vm._l((_vm.timeslots), function(slot) {
    return _c('el-option', {
      key: slot.id,
      attrs: {
        "label": slot.title,
        "value": slot.id
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.analyticsBlocks), function(block) {
    return _c('div', {
      key: block.unit,
      staticClass: "col-md-3",
      on: {
        "click": function($event) {
          return _vm.selectBlock(block)
        }
      }
    }, [_c('voice-analytics-unit-block', {
      attrs: {
        "unit": block.unit,
        "unit-class": block.unitClass,
        "period": block.period,
        "description": block.description,
        "received": block.received,
        "growth": block.growth,
        "stats": block.stats,
        "approved": block.approved,
        "flagged": block.flagged,
        "pending": block.pending,
        "selected": block.selected
      },
      on: {
        "previous": function($event) {
          return _vm.onBlockPrevious(block)
        },
        "next": function($event) {
          return _vm.onBlockNext(block)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('filters-sidebar', {
    ref: "filtersSidebar",
    attrs: {
      "transcripts": _vm.transcripts,
      "tone-options": _vm.getToneOptions,
      "tag-options": _vm.getTagOptions
    },
    on: {
      "apply-filters": function($event) {
        _vm.filters = $event
      },
      "reset-filters": _vm.clearFilters
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle",
      "justify": "space-between",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "flex": 1
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Search by name, transcript, tags...",
      "prefix-icon": "el-icon-search",
      "clearable": "",
      "size": "small"
    },
    on: {
      "clear": function($event) {
        _vm.searchQuery = ''
      }
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "flex": 0
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button-group', {
    attrs: {
      "size": "small"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.viewMode !== 'table',
      "size": "small"
    },
    on: {
      "click": _vm.onExportSelected
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export\n                    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.viewMode !== 'table',
      "size": "small"
    },
    on: {
      "click": _vm.onBulkApprove
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Approve Selected\n                    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.toggleViewMode
    }
  }, [_c('i', {
    class: _vm.viewMode === 'table' ? 'fa fa-th-large' : 'fa fa-list'
  }), _vm._v("\n                      " + _vm._s(_vm.viewMode === 'table' ? 'Grid' : 'Table') + "\n                    ")])], 1)], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [(_vm.viewMode === 'table') ? _c('voice-notes-table', {
    ref: "voiceNotesTable",
    attrs: {
      "transcripts": _vm.getTranscripts,
      "loadingTranscripts": _vm.loadingTranscripts
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "preview-audio": _vm.previewVoiceNote,
      "approve-on-air": _vm.onApproveOnAir,
      "toggle-flag": _vm.onToggleFlag,
      "refresh-transcripts": _vm.onRefreshTranscripts
    }
  }) : _c('voice-notes-grid', {
    attrs: {
      "transcripts": _vm.getTranscripts,
      "loadingTranscripts": _vm.loadingTranscripts
    },
    on: {
      "preview-audio": _vm.previewVoiceNote,
      "approve-on-air": _vm.onApproveOnAir,
      "toggle-flag": _vm.onToggleFlag
    }
  })], 1)])])], 2)]), _vm._v(" "), _c('audio-preview-modal', {
    attrs: {
      "visible": _vm.previewVisible,
      "note": _vm.previewNote
    },
    on: {
      "update:visible": function($event) {
        _vm.previewVisible = $event
      },
      "close": _vm.closePreview
    }
  }), _vm._v(" "), _c('approve-modal', {
    attrs: {
      "visible": _vm.approveVisible,
      "note": _vm.approveNote,
      "loading": _vm.approvingLoading
    },
    on: {
      "update:visible": function($event) {
        _vm.approveVisible = $event
      },
      "approve": _vm.handleApproveSubmit,
      "close": _vm.closeApprove
    }
  }), _vm._v(" "), _c('flag-modal', {
    attrs: {
      "visible": _vm.flagVisible,
      "note": _vm.flagNote,
      "loading": _vm.flaggingLoading
    },
    on: {
      "update:visible": function($event) {
        _vm.flagVisible = $event
      },
      "flag": _vm.handleFlagSubmit,
      "close": _vm.closeFlag
    }
  }), _vm._v(" "), _c('bulk-approve-modal', {
    attrs: {
      "visible": _vm.bulkApproveVisible,
      "notes": _vm.selectedRows,
      "loading": _vm.bulkApprovingLoading
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkApproveVisible = $event
      },
      "bulk-approve": _vm.handleBulkApproveSubmit,
      "close": _vm.closeBulkApprove
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 header-title"
  }, [_c('h2', [_c('span', {
    staticClass: "fa fa-microphone"
  }), _vm._v("\n        Voice Intelligence\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08982428","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/voiceIntelligence/VoiceIntelligenceDashboard.vue
// module id = 3125
// module chunks = 3